import React from 'react';
import { Loader2 } from 'lucide-react';
import teelogixLogo from '@assets/svgs/textLogo.svg';

interface AppLoadingScreenProps {
  message?: string;
  subMessage?: string;
}

const AppLoadingScreen: React.FC<AppLoadingScreenProps> = ({
  message = "Setting up your admin panel…",
  subMessage = "Preparing your workspace..."
}) => {
  return (
    <div className="fixed inset-0 bg-gradient-to-br from-emerald-50 via-white to-green-50 flex items-center justify-center z-[9999]">
      <div className="text-center">
        <div className="relative">
          <div className="absolute inset-0 bg-emerald-200 rounded-full blur-2xl opacity-20 animate-pulse"></div>
          <div className="relative bg-white rounded-2xl shadow-xl px-12 py-10 border border-emerald-100">
            <div className="flex flex-col items-center space-y-6">
              <div className="relative">
                <div className="absolute inset-0 bg-gradient-to-r from-emerald-400 to-green-400 rounded-full blur-xl opacity-50 animate-pulse"></div>
                <Loader2 className="relative w-12 h-12 text-emerald-600 custom-spin" />
              </div>
              
              <div className="space-y-2">
                <h2 className="text-xl font-semibold text-gray-800">{message}</h2>
                <p className="text-sm text-gray-500 animate-pulse">{subMessage}</p>
              </div>
              
              <div className="flex space-x-1">
                <div className="w-2 h-2 bg-emerald-400 rounded-full animate-bounce" style={{ animationDelay: '0ms' }}></div>
                <div className="w-2 h-2 bg-emerald-400 rounded-full animate-bounce" style={{ animationDelay: '150ms' }}></div>
                <div className="w-2 h-2 bg-emerald-400 rounded-full animate-bounce" style={{ animationDelay: '300ms' }}></div>
              </div>
            </div>
          </div>
        </div>
        
        <div className="mt-8 flex flex-col items-center justify-center gap-2">
          <span className="text-xs text-gray-400">Powered by</span>
          <img src={teelogixLogo} alt="TeeLogix" className="h-8 w-auto" />
        </div>
      </div>
    </div>
  );
};

export default AppLoadingScreen;